"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionErrorNotifier = void 0;
const React = __importStar(require("react"));
const __1 = require("..");
/**
 * A hook to listen out for actions being dispatched to the store to indicate an error in a Thunk action
 * @param clearActionType The action that indicates the error is cleared (typically `*_REQUEST`, as this means a new run of the action)
 * @param errorActionType The action that indicates an error has occurred (typically `*_FAILURE`)
 *
 * @returns `errored`, a boolean to indicate if the latest invocation of the action has errored
 */
const useActionErrorNotifier = (clearActionType, errorActionType) => {
    const { registerActionListener, deregisterActionListener } = React.useContext(__1.AppContext);
    const [errored, setErrored] = React.useState(false);
    React.useEffect(() => {
        if (Array.isArray(clearActionType)) {
            // Map each action listener key to its action
            const actionMapping = {};
            clearActionType.forEach((clearAction) => {
                const key = Math.random().toString(36);
                registerActionListener(key, clearAction, () => setErrored(false));
                actionMapping[key] = clearAction;
            });
            return () => {
                Object.entries(actionMapping).forEach(([key, act]) => deregisterActionListener(key, act));
            };
        }
        else {
            const key = Math.random().toString(36);
            registerActionListener(key, clearActionType, (action) => {
                setErrored(false);
            });
            return () => deregisterActionListener(key, clearActionType);
        }
    }, []);
    React.useEffect(() => {
        if (Array.isArray(errorActionType)) {
            // Map each action listener key to its action
            const actionMapping = {};
            errorActionType.forEach((errorAction) => {
                const key = Math.random().toString(36);
                registerActionListener(key, errorAction, () => setErrored(true));
                actionMapping[key] = errorAction;
            });
            return () => {
                Object.entries(actionMapping).forEach(([key, act]) => deregisterActionListener(key, act));
            };
        }
        else {
            const key = Math.random().toString(36);
            registerActionListener(key, errorActionType, (action) => {
                setErrored(true);
            });
            return () => deregisterActionListener(key, errorActionType);
        }
    }, []);
    return errored;
};
exports.useActionErrorNotifier = useActionErrorNotifier;
//# sourceMappingURL=errorNotifier.js.map